<template>
  <v-row dense>
    <v-col cols="12" sm="12" md="12">
      <v-banner
        color="blue-grey lighten-5"
        class="br black--text"
        shaped
        single-line
      >
        Signos vitales
      </v-banner>
    </v-col>
    <v-col
      cols="12"
      sm="3"
      md="3"
      v-for="(input, index) in inputsVitalSign"
      :key="index"
    >
      <p align="left">
        <strong>{{ input.label }}</strong
        >:
        <span
          v-if="
            $utilFront.nonEmpty(vitalSign[index]) &&
            $utilFront.nonEmpty(vitalSign[index].description)
          "
        >
          {{ vitalSign[index].description }} <small>{{ input.suffix }}</small>
        </span>
        <span v-else>&ensp;- - - </span>
      </p>
    </v-col>
  </v-row>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  props: {
    model: Object,
    suimFlag: Number,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      inputsVitalSign: [],
      vitalSign: {},
      panelDis: true,
      oldsuimFlag: false,
    };
  },
  async created() {
    switch (this.suimFlag) {
      case 1:
        await this.getVitalSignByPatientNewSuim();
        break;
    }
  },
  watch: {
    "model.vitalSigns": function () {
      this.vitalSign = this.model.vitalSigns;
    },
    "model.inputsVitalSigns": function () {
      this.inputsVitalSign = this.model.inputsVitalSigns;
    },
  },
  methods: {
    async getVitalSignByPatientNewSuim() {
      try {
        this.inputsVitalSign = this.model.vitalSigns.map((input) => {
          let type = "";
          if (input.type === 1) {
            type = "number";
          } else if (input.type === 2) {
            type = "text";
          }
          let required = 0;
          if (input.required === 1) {
            required = true;
          } else if (input.required === 2) {
            required = false;
          }
          return {
            idVitalSignType: input.idVitalSignType,
            type: type,
            label: input.name,
            suffix: input.suffix,
            status: input.status,
            required: required,
            value: input.value,
            idVitalSigns: input.idVitalSign,
          };
        });
        this.vitalSign = this.model.vitalSigns.map((values) => {
          return {
            description: values.value,
            idVitalSigns: values.idVitalSign,
            idVitalSignType: values.idVitalSignType,
            typeName: values.name,
            suffix: values.suffix,
          };
        });
      } catch (error) {
        // console.log(error);
      }
    },
    // addVitalSigns() {
    //   const idPatient = this.dataPatient.idPatient;
    //   let i = 1;
    //   let objVitalSign = [];
    //   for (let key in this.vitalSign) {
    //     let arrVital = {
    //       description: this.vitalSign[key].description,
    //       idVitalSigns: this.vitalSign[key].idVitalSigns,
    //       vitalSignType: {
    //         idVitalSignType: i,
    //       },
    //     };

    //     objVitalSign.push(arrVital);
    //     i++;
    //   }

    //   const postVitalSign = {
    //     patient: {
    //       idPatient: idPatient,
    //     },
    //     vitalSigns: objVitalSign,
    //   };

    //   VitalSignRequest.addVitalSign(postVitalSign).then((res) => {
    //     if (res.data.code === 200) {
    //       this.panelDis = true;
    //       this.$utilFront.notifications(
    //         "Signos vitales registrados correctamente",
    //         "SUCCESS"
    //       );
    //     } else if (res.data.code === 401) {
    //       this.unauthorized();
    //     } else {
    //       this.$utilFront.notifications(
    //         "Error al registrar signos vitales",
    //         "ERROR"
    //       );
    //     }
    //   });
    // },
    changeValidation(old) {
      for (const key in this.inputsVitalSign) {
        if (old < 18) {
          if (this.inputsVitalSign[key].label === "IMC") {
            this.inputsVitalSign[key].required = false;
          }
          if (this.inputsVitalSign[key].label === "Estado de peso corporal") {
            this.inputsVitalSign[key].required = false;
          }
        } else if (old >= 18) {
          if (this.inputsVitalSign[key].label === "IMC") {
            this.inputsVitalSign[key].required = true;
          }
          if (this.inputsVitalSign[key].label === "Estado de peso corporal") {
            this.inputsVitalSign[key].required = true;
          }
        }
      }
    },
    calculateIMC() {
      let talla = 0;

      let imc = 0;

      let clasificacion = "";

      if (this.oldValidation >= 18) {
        if (this.vitalSign[0].description) {
          talla = this.vitalSign[0].description / 100;
        }

        if (this.vitalSign[1].description) {
          imc = this.vitalSign[1].description / Math.pow(talla, 2);

          imc = parseFloat(imc).toFixed(2);
          if (imc < parseFloat("18.5").toFixed(2)) {
            clasificacion = "Insuficiencia ponderal";
          } else if (
            imc >= parseFloat("18").toFixed(2) &&
            imc < parseFloat("25").toFixed(2)
          ) {
            clasificacion = "Normal";
          } else if (
            imc >= parseFloat("25").toFixed(2) &&
            imc < parseFloat("30").toFixed(2)
          ) {
            clasificacion = "Sobrepeso";
          } else if (
            imc >= parseFloat("30").toFixed(2) &&
            imc < parseFloat("35").toFixed(2)
          ) {
            clasificacion = "Obesidad tipo I";
          } else if (
            imc >= parseFloat("35").toFixed(2) &&
            imc < parseFloat("40").toFixed(2)
          ) {
            clasificacion = "Obesidad tipo II";
          } else if (imc >= parseFloat("40").toFixed(2)) {
            clasificacion = "Obesidad tipo III";
          }

          this.vitalSign[2].description = parseFloat(imc).toFixed(2);
          this.vitalSign[7].description = clasificacion;
        }
      }
    },
  },
};
</script>

<style></style>
